import BossModel from "@/models/BossModel";

export default class Day extends BossModel {

    static apiUrl = 'product/allowance/day';

    static entity = 'productAllowanceDays';

    static fields() {
        return {
            id: this.number(null).nullable(),
            product_allowance_id: this.number(null).nullable(),
            day_of_week: this.number(null).nullable(),
        }
    }
}
